<app-logo-placeholder *ngIf="isPortraitDevice" class="logo-marca" [brand]="brand" [isPortraitDevice]="isPortraitDevice"></app-logo-placeholder>

<app-financial-cart 
    class="dropdown"
    [financialData]="financialData"
    [brand]="brand"
    [model]="model"
    [isPortraitDevice]="isPortraitDevice"
    (isOpenedFinancialCart)="isOpenedFinancialCart($event)"
>
</app-financial-cart>
